module.exports = __webpack_public_path__ + "static/media/SM-ST-12 (2).76b547a9.mp3";